import { IDashboardBusinessControlsViewDTO, IDashboardBusinessControlsGetDTO, IDashboardBusinessControlGetStatusDTO } from './../../libs/coreapi-dto/accounting/dashboardBusinessControl';
import { DictionaryDataProvider } from './Common';
import CoreApiService from "../../system/api/coreApiService"
import { CoreApiResponse } from '../../libs/core-api-requests/common';
import DashboardBusinessControlsRequest from '../../libs/core-api-requests/dirs/dashboardBusinessControlsRequest';


export class DashboardBusinessControlsDataProvider {
    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        this._coreApiService = coreApiService
    }
    getDataRequest(): Promise<DashboardBusinessControlsRequest> {
        return this._coreApiService.dashboardBusinessControlsRequest;
    }
   
    getView(body: IViewBody, callback: (entity: IDashboardBusinessControlsViewDTO[], totalCount: number) => void, report?: (value) => void) {
        this.getDataRequest()
            .then(r => r.getView(body, e => {
                if (e.respType === 'isCompleted') {
                    try {
                        callback(e.data.entities, e.data.totalCount)
                    } catch (e) {
                        console.error(e)
                    }
                }
                else
                    throw new Error(e?.message.title ?? 'ServiceDataProvider getView !isCompleted');
            },))
    }
   
    getViewById(idGlobal: string, callback?: (data: IDashboardBusinessControlsGetDTO) => void) {
        this.getDataRequest()
            .then(r => r.getViewById(idGlobal, (e) => {
                if (e.respType === 'isCompleted') {
                    callback?.(e.data);
                }
                else
                    throw new Error(e.message.title);
            })
            );
    }

    sync(callback?: (e: CoreApiResponse<null>) => void) {
        this.getDataRequest().then((r) =>
            r.sync((e) => {
                if (e.respType === 'isCompleted') {
                    callback?.(e);
                }
            }
            ))
    }

    status(callback?: (e: CoreApiResponse<IDashboardBusinessControlGetStatusDTO>) => void) {
        this.getDataRequest().then((r) =>
            r.status((e) => {
                if (e.respType === 'isCompleted') {
                    callback?.(e);
                } else {
                    callback?.(e)
                }
            },
            )
        );
    }


}
